module.exports = __webpack_public_path__ + "img/3-7218.d35804dc.png";